export default __webpack_public_path__ + "static/media/reportsSelected.5f0008ca.svg";